import { prefixLink } from '@ms/config/app'

/**
 * 根据 bizType 判断是哪类专属红包，跳转对应页面, 优先级为 realsport > virtual > jackpot
 * bizType 值包括 1 - realsport, 2 - virtual, 3 - jackpot
 * @param {Array} bizType  玩法类型
 */
export const gotoUseVoucher = (bizType = []) => {
  const sortedBizType = bizType.sort()
  if (sortedBizType[0] === 2) {
    // virtual
    location.href = prefixLink('/virtual')
  } else if (sortedBizType[0] === 3) {
    // jackpot
    location.href = prefixLink('/jackpot')
  } else {
    // real sport
    location.href = prefixLink('/sports/list')
  }
}
